import { render, staticRenderFns } from "./DeudorList.vue?vue&type=template&id=b28c296a"
import script from "./DeudorList.vue?vue&type=script&lang=js"
export * from "./DeudorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports